import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import api from "@/lib/api";
import { fmtCurrency } from "@/lib/utils-app";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function AdminSubscriptionReturn() {
  const [sp] = useSearchParams();
  const ref = sp.get("ref");
  const mpStatus = sp.get("mp_status");
  const { refreshUser } = useAuth();
  const [status, setStatus] = useState("polling");
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!ref) {
      setStatus(mpStatus === "failure" ? "error" : "error");
      return;
    }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/admin/subscription/checkout/status/${ref}`);
        setInfo(data);
        if (data.status === "paid") {
          setStatus("paid");
          await refreshUser?.();
          return;
        }
        if (mpStatus === "failure" && attempts >= 3) {
          setStatus("error");
          return;
        }
        if (attempts >= 15) {
          setStatus("timeout");
          return;
        }
        setTimeout(poll, 2000);
      } catch {
        if (attempts >= 12) setStatus("error");
        else setTimeout(poll, 2000);
      }
    };
    poll();
  }, [ref, mpStatus, refreshUser]);

  return (
    <section className="min-h-screen flex items-center justify-center bg-[#0A0A0A] px-4" data-testid="admin-subscription-return">
      <div className="glass-strong p-10 rounded-sm text-center max-w-md w-full">
        {status === "polling" && (
          <>
            <Loader2 className="mx-auto animate-spin text-[#FFD700]" size={46} />
            <h1 className="font-display text-3xl text-white mt-4">Verificando pago…</h1>
            <p className="text-white/60 mt-2 text-sm">Confirmando tu suscripción con Mercado Pago.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="mx-auto text-green-400" size={64} />
            <h1 className="font-display text-4xl text-white mt-4">¡Suscripción renovada!</h1>
            <p className="text-white/60 mt-3 text-sm">
              Pago de{" "}
              <span className="text-[#FFD700] font-bold">{info?.amount ? fmtCurrency(info.amount) : ""}</span>{" "}
              confirmado.
            </p>
            <Link to="/admin" className="btn-primary mt-8 inline-block">
              Ir al panel
            </Link>
          </>
        )}
        {(status === "error" || status === "timeout") && (
          <>
            <XCircle className="mx-auto text-red-400" size={64} />
            <h1 className="font-display text-3xl text-white mt-4">Pago no confirmado</h1>
            <p className="text-white/60 mt-2 text-sm">
              {status === "timeout"
                ? "Aún no recibimos confirmación. Si ya pagaste, espera unos minutos e intenta de nuevo."
                : "El pago no se completó o fue rechazado."}
            </p>
            <Link to="/admin" className="btn-outline mt-8 inline-block">
              Volver al panel
            </Link>
          </>
        )}
      </div>
    </section>
  );
}
